module.exports = __webpack_public_path__ + "site/img/process_detail2.d051e7a7.png";